// Cor do CSS da marca vem dos tokens, não de hexadecimal na folha — ADR-0005.

import type { CSSProperties } from 'react';

import { borda, esteira, primitivas, sla, superficie, texto } from '@anery/design-system';

/**
 * `style` do elemento que carrega `className="anery-marca"`.
 *
 * São só as variáveis. O wrapper não pinta fundo nem reserva altura — a
 * página é do Shell, e a superfície branca é do cartão.
 */
export const variaveisDaMarca = {
  '--navy': texto.link,
  /** Preenchimento. Como tinta ele mede 2.56:1 — use `--teal-tinta`. */
  '--teal': superficie.teal,
  '--teal-tinta': texto.teal,
  '--roxo': texto.acento,
  '--rosa': esteira.barrado.borda,

  '--tinta': texto.primario,
  '--tinta-2': texto.secundario,
  '--tinta-3': texto.desabilitado,

  /**
   * Semáforo das frentes. São os tokens de `sla` — verde, âmbar, vermelho e
   * neutro —, e não cor nova: o contraste deles já está medido, e a régua de
   * "hexadecimal fora das primitivas" não aceitaria um pastel inventado aqui.
   *
   * Três lâmpadas cheias e um anel tracejado para "ainda não é a vez". O
   * âmbar é o pêssego da marca, então o amarelo do semáforo já era cor da
   * casa. Verde e vermelho vêm de `sucesso` e `erro`, que existem nas
   * primitivas justamente para o teal não acumular "secundária" e "deu certo".
   */
  '--sinal-ok': sla.ok.borda,
  '--sinal-ok-fundo': sla.ok.fundo,
  '--sinal-atencao': sla.atencao.borda,
  '--sinal-atencao-fundo': primitivas.pessego.claro,
  '--sinal-atencao-claro': sla.atencao.fundo,
  '--sinal-parado': sla.estourado.borda,
  '--sinal-parado-fundo': sla.estourado.fundo,
  '--sinal-espera': sla.semPrazo.borda,

  '--chao': superficie.cartao,
  '--chao-2': superficie.sutil,
  '--fio': borda.sutil,
} as CSSProperties;
